/* This is updated by the Jenkins script to reflect
   the value of the sha commit
   @see JenkinsFile
 */
export const commit_sha : string = 'PHEWEB VERSION : ee814ca9a486b8fc39a3452e3d1a4b0da70dc439';
